export async function getproduct(props: any = {}, data = {}) {
    return await props.di.GET("connector/product/getProduct", data);
}

export async function saveproduct(props: any = {}, data = {}) {
    return await props.di.POST("connector/product/saveProduct", data);
}